var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShippingTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8621 4H18.3405C18.6478 4 18.9453 4.15 19.1336 4.4L21.4138 7.47C21.6715 7.82 21.8103 8.24 21.8103 8.67V12C21.8103 12.55 21.3642 13 20.819 13H19.8276C19.8276 14.66 18.4991 16 16.8534 16C15.2078 16 13.8793 14.66 13.8793 13H7.93103C7.93103 14.66 6.60259 16 4.9569 16C3.31121 16 1.98276 14.66 1.98276 13C0.892241 13 0 12.1 0 11V2C0 0.9 0.892241 0 1.98276 0H13.8793C14.9698 0 15.8621 0.9 15.8621 2V4ZM3.96558 13C3.96558 13.55 4.41171 14 4.95696 14C5.50222 14 5.94834 13.55 5.94834 13C5.94834 12.45 5.50222 12 4.95696 12C4.41171 12 3.96558 12.45 3.96558 13ZM18.3406 5.5L20.2837 8H15.8621V5.5H18.3406ZM15.8621 13C15.8621 13.55 16.3083 14 16.8535 14C17.3988 14 17.8449 13.55 17.8449 13C17.8449 12.45 17.3988 12 16.8535 12C16.3083 12 15.8621 12.45 15.8621 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippingTruck);
export default __webpack_public_path__ + "static/media/shipping-truck.c9d67b23edf513bd8a7ea9f8a7963ece.svg";
export { ForwardRef as ReactComponent };